var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_590)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72332 1.24359C4.34134 1.24359 0.789062 4.79587 0.789062 9.17785C0.789062 13.5598 4.34134 17.1121 8.72332 17.1121C13.1053 17.1121 16.6576 13.5598 16.6576 9.17785C16.6576 4.79587 13.1053 1.24359 8.72332 1.24359ZM9.26429 5.39105V8.63688H12.5101V9.71882H9.26429V12.9647H8.18235V9.71882H4.93652V8.63688H8.18235V5.39105H9.26429Z",
    fill: "#08A98A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3111,
    height: 17.3111,
    fill: "white",
    transform: "translate(0.0664062 0.522247)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.d6fd4ead1071ef71235c6b46bd61f4bb.svg";
export { ForwardRef as ReactComponent };